import debounce from 'lodash/debounce';
import 'jquery-match-height';

const $gallery = $('.product-gallery');

if ($gallery.length) {
  require.ensure(['waypoints-core'], () => {
    const Waypoint = require('waypoints-core');

    const self = {};

    /** Initialise the module. */
    self.initialise = function initialise() {
      $('.slider-for', $gallery).on('init', function init() {
        $('.carousel-item', $(this)).show();
        $(window).trigger('resize');
      });

      $('.slider-for', $gallery).on('afterChange', () => {
        $('.zoomContainer').remove();
        $(window).trigger('resize');
      });

      $('.slider-for', $gallery).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav',
      });

      $('.slider-nav', $gallery).on('init', () => {
        $('.slider-nav', $gallery).css('visibility', 'visible');
        $(window).trigger('resize');
      });

      if ($('.carousel-product-nav').children().length < 2) {
        $('.carousel-product-nav').hide();
      }

      $('.slider-nav', $gallery).slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        arrows: true,
        vertical: true,
        focusOnSelect: true,
        /* eslint-disable max-len */
        nextArrow: '<button class="slick-next" type="button"><span class="sr-only">Previous</span></button>',
        prevArrow: '<button class="slick-prev" type="button"><span class="sr-only">Next</span></button>',
        /* eslint-enable max-len */
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              vertical: false,
              slidesToShow: 5,
            },
          },
        ],
      });

      // eslint-disable-next-line no-unused-vars
      const waypoint = new Waypoint({
        element: document.getElementsByClassName('product-nav')[0],
        handler(direction) {
          if (direction === 'down') {
            $('body').addClass('show-scroll-up');
          } else {
            $('body').removeClass('show-scroll-up');
          }
        },
      });

      function doneResizing() {
        $('.slider-nav', $gallery).slick('reinit');
        $('.slider-for', $gallery).slick('reinit');
      }

      $(window).resize(() => {
        debounce(doneResizing, 500);
      });
    };

    setTimeout(() => {
      self.initialise();
    }, 1000);
  });
}
